import React          from 'react';
import MenuButtons    from './buttons';
import handleNavigate from 'functions/handleNavigate';
import zeroInput      from 'functions/tests/zeroInput';
import words          from 'utils/words';
import { makeStyles } from "makeStyles";


const useStyles = makeStyles()(
    () => ({
    root: {
        position:     'fixed',
        top:          0,
        right:        0,
        display:      'flex',
        borderLeft:   '1px solid #BBB',
    },
    text: {
      marginRight:     10,
      marginTop:       10,
      height:          50,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      fontWeight:      'bold',
      color:           '#333',      
    }
  })
);

type MenuProps = {
    menuSize:      number;
    level:         number;
    wideScreen:    boolean;
    goToNextTest:  () => void;
    goToNextLevel: () => void;
}

const Menu: React.FC<MenuProps> = ({ 
    menuSize, 
    level,
    wideScreen,
    goToNextTest,
    goToNextLevel,
}) => {

  const { classes } = useStyles();


  const rootStyle = React.useMemo(() => {
    return {
        width:           wideScreen ? menuSize : '100vw',
        height:          wideScreen ? '100vh' : 50,
        flexFlow:        wideScreen ? 'column' : 'row',
        backgroundColor: wideScreen ? '#EEF' : 'transparent',
        boxShadow:       wideScreen ? '0px 0px 8px rgba(0,0,0,0.25)' : undefined,

    }
  },[menuSize, wideScreen])

  const buttonsArr = React.useMemo(() => {

     const arr = [
       {
         text: 'goHome',
         func: () => handleNavigate('home')
       }
     ]

     const tirgulButtons = [
       {
         text: 'next',
         func: goToNextTest
       },
       {
        text: 'nextLevel',
        func: goToNextLevel
       },
       {
        text: 'zeroInput',
        func: zeroInput
       }
     ]

     const mazegetButton = {
      text: 'goToTirgul',
      func: () => handleNavigate('tirgul')
     }
  
     if ( level === -1 ) {
       return arr.concat(mazegetButton)
     }

     return arr.concat(tirgulButtons)
     
  },[level, goToNextTest, goToNextLevel])

  return (
     <div 
       dir       = 'rtl'
       className = { classes.root }
       style     = { rootStyle }
     >
       {
         wideScreen && level !== -1 &&
         <div 
          dir = 'rtl'
          className = { classes.text }
         >
            { `${ words.level } : ${ level + 1 }` } 
         </div>
       }
       {
         buttonsArr.map((val, ind) => {
           return(
              <MenuButtons
                key          = { `MenuButton${ val.text }${ ind }` } 
                menuSize     = { menuSize }
                wideScreen   = { wideScreen }
                handleClick  = { val.func }
                text         = { words[val.text] }
              />
           )
         })
       }
     </div>
  );
}



export default Menu;








